export default function (path) {
  return (isRelativeToDomainRoot(path)) ? path.substring(1) : path
}

function isRelativeToDomainRoot (uri) {
  return uri.indexOf('/') === 0
}
